import { Box, Stack } from '@mui/material';
import useResponsive from '@/hooks/useResponsive';
import Typography from '@/components/Typography';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';
import getLocalFile from '@/utils/getLocalFile';

const CustomBreadcrumbs: React.FC<{
  parentTitle: string;
  isPricePage?: boolean;
}> = ({ parentTitle, isPricePage }) => {
  const { matches } = useResponsive();
  const router = useRouter();
  const {
    query: { symbol }
  } = useRouter();
  const marketName = symbol?.toString().toUpperCase() || '';
  const data = getLocalFile(marketName, 'info');
  const title = data?.Information?.name_fa;

  const parentPathname = router.asPath.slice(0, router.asPath.indexOf('/', 1));

  return (
    <Stack
      itemScope
      flexDirection="row"
      alignItems="center"
      itemType="https://schema.org/BreadcrumbList"
      sx={{ pt: matches({ lg: 7, xs: 3 }) }}
      gap={1}
      position="relative"
      zIndex={3}
    >
      <Box
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
      >
        <a
          itemProp="item"
          key="1"
          href="/"
          style={{ textDecoration: 'none', color: '#808A9D' }}
        >
          <Typography
            itemProp="name"
            variant={matches({ lg: 'body2', xs: 'body3' })}
          >
            صرافی رابکس
          </Typography>
        </a>
        <meta itemProp="position" content="1" />
      </Box>
      <Image
        alt=""
        src="/assets/breadcrumb/separator.svg"
        width={12}
        height={12}
        style={{ margin: '0px 6px' }}
      />
      <Box
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
      >
        <a
          itemProp="item"
          key="2"
          href={parentPathname}
          style={{ textDecoration: 'none', color: '#808A9D' }}
        >
          <Typography
            itemProp="name"
            variant={matches({ lg: 'body2', xs: 'body3' })}
          >
            {parentTitle}
          </Typography>
        </a>
        <meta itemProp="position" content="2" />
      </Box>
      <Image
        alt=""
        src="/assets/breadcrumb/separator.svg"
        width={12}
        height={12}
        style={{ margin: '0px 6px' }}
      />
      <Box
        itemProp="itemListElement"
        itemScope
        itemType="https://schema.org/ListItem"
      >
        <a
          itemProp="item"
          href={router.asPath}
          key="3"
          style={{ textDecoration: 'none', color: '#222531' }}
        >
          <Typography
            itemProp="name"
            key="3"
            variant={matches({ lg: 'body2', xs: 'body3' })}
          >
            {isPricePage ? `قیمت ارز ${title}` : `خرید ${title}`}
          </Typography>
        </a>
        <meta itemProp="position" content="3" />
      </Box>
    </Stack>
  );
};
export default CustomBreadcrumbs;
